import React from "react";
import { Controller, Control, FieldValues, Path } from "react-hook-form";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SxProps } from "@mui/material";
import { textFieldStyle } from "../Checkout/CouponStyles";

export interface SelectOption {
    id: number | string;
    descripcion: string;
}

interface ControlledSelectProps<T extends FieldValues> {
    control: Control<T>;
    name: Path<T>;
    label: string;
    options: SelectOption[];
    required?: boolean;
    disabled?: boolean;
    sx?: SxProps;
}

export const ControlledSelect = <T extends FieldValues>({
    control,
    name,
    label,
    options,
    required,
    disabled,
    sx,
}: ControlledSelectProps<T>): React.ReactElement => (
    <Controller
        control={control}
        name={name}
        render={({ field, fieldState }) => (
            <FormControl
                fullWidth
                error={!!fieldState.error}
                disabled={disabled}
                sx={{ ...textFieldStyle, ...sx }}
            >
                <InputLabel>
                    {label}
                    {required ? " *" : ""}
                </InputLabel>
                <Select
                    {...field}
                    value={field.value ?? ""}
                    label={`${label}${required ? " *" : ""}`}
                >
                    {options.map((opt) => (
                        <MenuItem key={opt.id} value={opt.id}>
                            {opt.descripcion}
                        </MenuItem>
                    ))}
                </Select>
                {fieldState.error && <FormHelperText>{fieldState.error.message}</FormHelperText>}
            </FormControl>
        )}
    />
);
